import React, { useRef, useState } from "react";
import { fileToResizedDataUrl } from "../../photoUtils";
import { useLanguage } from "../../i18n";

function Slot({ label, dataUrl, onChange }: { label: string; dataUrl: string; onChange: (dataUrl: string) => void }) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [busy, setBusy] = useState(false);
  const { t } = useLanguage();

  async function handleFile(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file || !file.type.startsWith("image/")) return;
    setBusy(true);
    try {
      onChange(await fileToResizedDataUrl(file));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="aadhaar-slot">
      <input ref={inputRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleFile} />
      {dataUrl ? (
        <div className="aadhaar-slot-filled">
          <img src={dataUrl} alt="" onClick={() => inputRef.current?.click()} />
          <button
            type="button"
            className="aadhaar-slot-remove"
            onClick={() => onChange("")}
            aria-label={t("assignTenantForm.removeAadhaarPhotoAria")}
          >
            &times;
          </button>
        </div>
      ) : (
        <button type="button" className="aadhaar-slot-add" disabled={busy} onClick={() => inputRef.current?.click()}>
          <span>{busy ? "…" : "+"}</span>
          <small>{label}</small>
        </button>
      )}
    </div>
  );
}

export function AadhaarPhotoFields({
  front,
  back,
  onChangeFront,
  onChangeBack,
}: {
  front: string;
  back: string;
  onChangeFront: (dataUrl: string) => void;
  onChangeBack: (dataUrl: string) => void;
}) {
  const { t } = useLanguage();
  return (
    <div className="field">
      <label>{t("assignTenantForm.aadhaarPhotosLabel")}</label>
      <div className="aadhaar-slots">
        <Slot label={t("assignTenantForm.aadhaarFront")} dataUrl={front} onChange={onChangeFront} />
        <Slot label={t("assignTenantForm.aadhaarBack")} dataUrl={back} onChange={onChangeBack} />
      </div>
    </div>
  );
}
